(function () {
  'use strict';

  function initPopup(popup) {
    if (!popup || popup.getAttribute('data-newsletter-popup-ready') === 'true') return;
    popup.setAttribute('data-newsletter-popup-ready', 'true');

    var cookieName = popup.getAttribute('data-cookie-name') || 'newsletter-popup-dismissed';
    var designMode = popup.getAttribute('data-design-mode') === 'true';
    var delaySeconds = parseInt(popup.getAttribute('data-delay'), 10);
    var cookieDays = parseInt(popup.getAttribute('data-cookie-days'), 10);
    var showTimer = null;

    if (isNaN(delaySeconds)) delaySeconds = 4;
    if (isNaN(cookieDays) || cookieDays < 1) cookieDays = 28;

    function hasDismissCookie() {
      var needle = cookieName + '=';
      return document.cookie.split(';').some(function (part) {
        return part.trim().indexOf(needle) === 0;
      });
    }

    function setDismissCookie() {
      var expires = new Date();
      expires.setDate(expires.getDate() + cookieDays);
      document.cookie = cookieName + '=1; expires=' + expires.toUTCString() + '; path=/; SameSite=Lax';
    }

    function showPopup() {
      if (document.documentElement.hasAttribute('data-signup-lightbox-opened')) return;
      popup.setAttribute('aria-hidden', 'false');
      popup.classList.add('is-visible');
    }

    function hideForLightbox() {
      window.clearTimeout(showTimer);
      popup.remove();
    }

    if (!designMode && hasDismissCookie()) {
      popup.remove();
      return;
    }

    var closeButton = popup.querySelector('[data-newsletter-popup-close]');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        if (!designMode) setDismissCookie();
        window.setTimeout(function () {
          popup.remove();
        }, 0);
      });
    }

    var cta = popup.querySelector('[data-newsletter-popup-cta]');
    if (cta) {
      cta.addEventListener('click', function () {
        if (!designMode) setDismissCookie();
        window.setTimeout(function () {
          popup.remove();
        }, 0);
      });
    }

    document.addEventListener('signup-lightbox:opened', hideForLightbox);

    showTimer = window.setTimeout(showPopup, designMode ? 0 : delaySeconds * 1000);
  }

  function schedulePopup(popup) {
    if (!popup || popup.getAttribute('data-newsletter-popup-bound') === 'true') return;
    popup.setAttribute('data-newsletter-popup-bound', 'true');

    if (document.documentElement.hasAttribute('data-signup-lightbox-opened')) return;

    initPopup(popup);
  }

  function init() {
    schedulePopup(document.querySelector('[data-newsletter-popup]'));
  }

  init();

  document.addEventListener('shopify:section:load', function (event) {
    schedulePopup(event.target.querySelector('[data-newsletter-popup]'));
  });
})();
